import { APIcaller, APIcallerv2 } from './APIcaller';

const getLossCategoriesByClientIdAndLossType = (lossType) =>
  APIcallerv2.apiGet('/losses/categories', { lossType });

const getLossCategoriesByClientId = () => APIcallerv2.apiGet(`/losses/categories/by-client`);

const getDatesWithLossesForStores = (type, storeIds, startDate, endDate) =>
  APIcaller.apiPost('/loss/dates', {
    type,
    storeIds,
    startDate,
    endDate,
  });

const getLossesList = (type, storeIds, startDate, endDate) =>
  APIcaller.apiPost('/loss/list', {
    type,
    storeIds,
    startDate,
    endDate,
  });

const createLosses = (type, storeId, date, losses) =>
  APIcaller.apiPost('/loss/createByBatch', {
    type,
    date,
    losses,
    storeId,
  });

const deleteLosses = (lossIds) =>
  APIcaller.apiDelete('/loss', {
    lossIds,
  });

const getLossesAnalytics = (storeIds, startDate, endDate, lossCategoryIds, ingredientCategoryIds) =>
  APIcaller.apiPost('/order/analytics/losses', {
    storeIds,
    startDate,
    endDate,
    lossCategoryIds,
    ingredientCategoryIds,
  });

const upsertByBatch = (losses, storeId, date) =>
  APIcaller.apiPost('/loss/upsert', {
    losses,
    storeId,
    date,
  });

const getLossesByStoreIdAndDates = (storeIds, startDate, endDate, { withPictures = true } = {}) =>
  APIcallerv2.apiPost(`/losses/list?withPictures=${withPictures}`, {
    storeIds,
    startDate,
    endDate,
  });

const updateCategories = (clientId, categories) =>
  APIcaller.apiPost(`/loss/categories`, {
    categories,
    clientId,
  });

const assignLossCategories = () => {
  console.warn('Assign Loss Categories TBI');
};

export const lossService = {
  assignLossCategories,
  createLosses,
  deleteLosses,
  getDatesWithLossesForStores,
  getLossCategoriesByClientId,
  getLossCategoriesByClientIdAndLossType,
  getLossesAnalytics,
  getLossesByStoreIdAndDates,
  getLossesList,
  updateCategories,
  upsertByBatch,
};
